import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css, cx } from 'emotion';
const contributorImage = css `
	border-radius: 100%;
	object-fit: cover;
	height: 100%;
	width: 100%;
`;
const backgroundStyles = (palette) => css `
		background-color: ${palette.background.avatar};
	`;
export const Avatar = ({ imageSrc, imageAlt, palette }) => {
    return (_jsx("img", { src: imageSrc, alt: imageAlt, className: cx(backgroundStyles(palette), contributorImage) }, void 0));
};
